import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReferralClinicalNote } from '@principle-theorem/principle-core';
import {
  IClinicalNote,
  IReferral,
  IReferralClinicalNote,
  IReferralClinicalNotesChanged,
  ReferralActor,
} from '@principle-theorem/principle-core/interfaces';
import { asyncForEach, Firestore, WithRef } from '@principle-theorem/shared';
import { ReferralService } from './referral.service';

@Injectable()
export class ReferralClinicalNotesService {
  private _referralService = inject(ReferralService);
  private _snackBar = inject(MatSnackBar);

  async updateClinicalNotes(
    referral: WithRef<IReferral>,
    currentUser: ReferralActor,
    clinicalNotes: IReferralClinicalNotesChanged
  ): Promise<void> {
    try {
      await asyncForEach(clinicalNotes.added, async (note) => {
        await this.addClinicalNote(referral, note, currentUser);
      });

      await asyncForEach(clinicalNotes.removed, async (refNote) => {
        await this.removeClinicalNote(refNote);
      });

      if (clinicalNotes.added.length > 0 || clinicalNotes.removed.length > 0) {
        await this._referralService.updateLastActivityBy(referral, currentUser);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error updating clinical notes for referral:', error);
      this._snackBar.open('Error updating clinical notes');
      throw error;
    }
  }

  async addClinicalNote(
    referral: WithRef<IReferral>,
    clinicalNote: WithRef<IClinicalNote>,
    actor: ReferralActor
  ): Promise<void> {
    await Firestore.addDoc(
      ReferralClinicalNote.col(referral),
      ReferralClinicalNote.init({
        clinicalNote,
        actor,
      })
    );
  }

  async removeClinicalNote(
    referralClinicalNote: WithRef<IReferralClinicalNote>
  ): Promise<void> {
    await Firestore.updateDoc(referralClinicalNote.ref, { deleted: true });
  }
}
